<!-- Load and be able to update users name_first and name_last as well as phone, avatar, title, and bio -->
<template>
    <b-container>
        <h1>Edit Profile</h1>
        <hr>
        <label for="name_first" class="mt-2">First Name:</label>
        <b-form-input v-model="user.name_first" placeholder="Edit first name here..."></b-form-input>
        <label for="name_last" class="mt-2">Last Name:</label>
        <b-form-input v-model="user.name_last" placeholder="Edit last name here..."></b-form-input>
        <label for="policy_types_id" class="mt-2">Title:</label>
        <b-form-input v-model="user.title" placeholder="Edit title here..."></b-form-input>
        <label for="policy_types_id" class="mt-2">Phone Number:</label>
        <b-form-input v-model="user.phone" type="tel" placeholder="Edit phone number here..."></b-form-input>
        <label for="policy_types_id" class="mt-2">Bio:</label>
        <b-form-textarea v-model="user.bio" placeholder="Edit bio here..."></b-form-textarea>
        <label for="avatars" class="mt-2">Avatars:</label>
        <b-form-select v-model="user.avatar" :options="avatars"></b-form-select>
        <hr>
        <b-button variant="primary" @click="updateUser" class="float-right">Update Profile</b-button>
    </b-container>
</template>


<script>

import UserDataService from '@/services/UserDataService';
import ReferenceDataService from '@/services/ReferenceDataService';

export default {
    data() {
        return {
            user: {},
            action: "update",
            avatars: []
        }
    },
    created() {
        UserDataService.getProfileById('user_profile').then((res) => {
            this.user = res.data;
            this.avatars = ReferenceDataService.avatars()
        })
    },

    methods: {
        //Add Try Catch here
        updateUser() {
            if (this.action === 'update') {
                UserDataService.update(this.user.id, this.user).then(() => {
                    window.location = `/user/${this.user.id}?update=true`;
                })
            }
        }
    }

}

</script>
